/**
 * Named access policies for AdminZone UI. Each policy lists who may see/use gated UI.
 *
 * Matching: the signed-in user's `localStorage.user.groups` rows (from `sec_groups`) are
 * checked against `allowedGroupIds` and/or `allowedDescriptions` (OR within each list;
 * both lists are OR'd — first match wins).
 *
 * Users with `sec_users.priv_admin = Y` are treated as belonging to the Administrator
 * group for any policy whose `allowedDescriptions` includes "Administrator"
 * (e.g. `managerOrAdmin`, `contractManage`).
 *
 * Add new keys here, then use `policy="yourKey"` on `<GroupPolicyGate />` or
 * `canAccessPolicy('yourKey')` from `useGroupAccess()`.
 *
 * Sidenav: set `allowedPolicy: "yourKey"` on a route (see `routes.js`); legacy `allowedRoles`
 * is still supported when `allowedPolicy` is omitted.
 * @typedef {{ allowedGroupIds?: number[], allowedDescriptions?: string[] }} GroupPolicyDefinition
 * @type {Record<string, GroupPolicyDefinition>}
 */
export const GROUP_POLICIES = {
  /** Create / edit / activate / suspend / terminate / delete contracts */
  contractManage: {
    allowedDescriptions: ["Manager", "Administrator", "Sales"],
  },
  /** Full customer record edit + sensitive service actions (existing behaviour) */
  managerOrAdmin: {
    allowedDescriptions: ["Manager", "Administrator"],
  },
};

export const GROUP_POLICY_KEYS = Object.freeze(Object.keys(GROUP_POLICIES));
